import { Observable, debounceTime, throttleTime, distinctUntilChanged, filter, map, switchMap, takeUntil } from 'rxjs';
import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseEditPopUpComponent } from '../../Services/BaseEditPopUpComponent';
import { ConfigService } from "../../Services/ConfigService";
import { PropertyItemService } from "../../Services/Custom/ServicePropertyItem";
import { SearchService } from '../../Services/Custom/ServiceSearch';

@Component({
	selector: 'PropertyItem-edit',
	templateUrl: 'PropertyItemEdit.html',

})
export class CustomerPropertyItemEditComponent extends BaseEditPopUpComponent {

	constructor(
		public configData: ConfigService,
		private iactiveModal: NgbActiveModal,
		private mySearchService: SearchService,
		private myPropertyItemService: PropertyItemService,
	) {
		super();

		this.activeModal = iactiveModal;
	}


	myItem = {} as TooBig4Car.Logic.PropertyItemCustomerVM;

	loadItem(item: TooBig4Car.Logic.PropertyItemCustomerVM) {
		this.myItem = item;
	}

	saveItem(form: NgForm) {
		this.isSaving = true;
		this.myPropertyItemService.saveCustomerFields(this.myItem)
			.pipe(takeUntil(this.obsToCloseSubject))
			.subscribe((returnVal) => {
				this.closePopUp(returnVal);
			},
				(error: any) => {
					this.showValidationErrors(error, form);
				});
	}

	sidemarkFormatter = (value: TooBig4Car.Logic.SearchResultBase) => value.SearchName;

	searchSidemark = (text$: Observable<string>) =>
		text$.pipe(
			filter(term => term != '' && term.length > 1),
			map(a => a.trim()),
			debounceTime(400),
			distinctUntilChanged(),
			switchMap((term: string) => this.mySearchService.searchSidemarks({
				CustomerAccountID: this.myItem.CustomerAccountID,
				SearchText: term,
				Include: true
			}))
		);

	onSelectSidemark($event: any, item: TooBig4Car.Logic.PropertyItem | TooBig4Car.Logic.PropertyItemCustomerVM) {
		$event.preventDefault();
		item.Sidemark = $event.item.SearchName;
	}
}
